"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zhLocaleData = require("i18next-icu/locale-data/zh");
exports.default = zhLocaleData;
//# sourceMappingURL=zh.js.map